import { GenericMessage } from "../../lib/messages";
export class ToolMessage extends GenericMessage {
}
;
